import Cookies from "js-cookie";
import Crypto from "crypto-js";

import env from "../config/env";
const { COOKIE_HASH } = env;

const clientStorage = {
  setItem: (key: string, value: string): void => {
    value = Crypto.AES.encrypt(
      Crypto.enc.Utf8.parse(value),
      COOKIE_HASH
    ).toString();
    let date = new Date();
    date.setTime(date.getTime() + 10 * 10 * 60 * 60 * 60);
    const expires = "expires=" + date.toUTCString();
    document.cookie = key + "=" + value + ";expires=" + expires + ";";
  },

  getItem: (key: string): string | null => {
    let value;
    value = Cookies.get(key);
    if (value) {
      return Crypto.AES.decrypt(value, COOKIE_HASH).toString(Crypto.enc.Utf8);
    }
    return null;
  },

  removeItem: (key: string): void => {
    return Cookies.remove(key);
  },
};

export default clientStorage;
